<template>
  <div
    v-if="showLoadingState < 7"
    key="loading state"
  >
    <AtomLoadingSecondary/>
  </div>

  <div
    v-else-if="ventaReemplazante"
    class="m-card-primary m-card-transition m-card-record-info"
  >
    <a
      class="m-card-record-link"
      @click="modalViewPendingChangePlan(Object.assign(ventaReemplazante, {'changePlan': true}))"
    >
      <p class="text-color-black-65">
        {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
      </p>
      <p class="recod-link-call-to-action recod-link-call-to-action-billing">
        {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.btn') }}
      </p>
    </a>
  </div>

  <div
    v-else-if="suscripcionNotificada"
    class="m-card-primary m-card-transition m-card-record-info"
  >
    <a
      class="m-card-record-link"
      @click="modalViewPendingChangePlan({
            'suscripcion': suscripcionNotificada,
            'venta': venta.venta
          })"
    >
      <p
        v-if="suscripcionNotificada.id_plan === venta.venta.id_plan"
        class="m-card-record-info m-card-record-link"
      >
        {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.paragraph') }}
      </p>
      <p
        v-else
        class="m-card-record-info m-card-record-link"
      >
        {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingChangePlan.paragraph') }}
      </p>
      <p class="recod-link-call-to-action recod-link-call-to-action-billing">
        {{ $t('mEditionBillingMyPaymentsSubscribedPlan.infoRigth.pendingPaymentMethod.btn') }}
      </p>
    </a>
  </div>

  <div
    v-else-if="producto && producto.cambio_plan"
    class="m-edition-billing-my-payments-change-plan-vidroop"
  >
    <div class="m-edition-billing-my-payments-change-plan-frecuency">
      <p class="a-input-side">
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="frecuencySelected"
            name="frecuencia"
            type="radio"
            value="mensual"
          >
          <span class="a-radiobutton-checkmark"></span>
          Mensual
        </label>
      </p>
      <p>
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="frecuencySelected"
            name="frecuencia"
            type="radio"
            value="anual"
          >
          <span class="a-radiobutton-checkmark"></span>
          Anual
        </label>
      </p>
    </div>

    <div class="m-edition-billing-my-payments-change-plan-frecuency">
      <p
        v-for="(divisa, index) in divisaByGestion"
        :key="index"
        class="a-input-side"
      >
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="divisaSelected"
            name="divisa"
            type="radio"
            :value="divisa.iso_code"
          >
          <span class="a-radiobutton-checkmark"></span>
          {{ divisa.nombre }}
        </label>
      </p>
    </div>

    <div>
      <div class="m-edition-billing-my-payments-change-plan-list">
        <article
          v-show="producto.mostrar && ((producto.pago && frecuencySelected === 'anual' && producto.planAnual) || (producto.pago && frecuencySelected === 'mensual' && producto.planMensual)) || (!producto.pago && (!producto.planMensual && !producto.planAnual))"
          class="m-card-primary m-card-transition m-edition-billing-my-payments-change-plan-list-element"
        >
          <span :class="`plan-list-element-circle plan-list-element-circle-${producto.class}`"></span>
          <h2 class="plan-list-element-name">{{ producto.nombre }}</h2>
          <div v-if="producto.trial_intervalo">
            <h2 class="plan-list-element-trial">
              Periodo de prueba:
            </h2>
            <span class="plan-list-element-trial-value">
              {{ producto.trial_intervalo }} {{ $filters.getFrequencyValue(producto.trial_frecuencia, 'name') }}
            </span>
          </div>
          <span v-if="producto.pago">
            <h3
              v-if="frecuencySelected === 'anual'"
              :class="`plan-list-element-price plan-list-element-price-${producto.class}`"
            >
              <span v-if="producto.planAnual">
                <span>
                  {{ producto.divisa.simbolo }}
                </span>
                {{ producto.planAnual.pago.precio }}
              </span>
            </h3>
            <h3
              v-if="frecuencySelected === 'mensual'"
              :class="`plan-list-element-price plan-list-element-price-${producto.class}`"
            >
              <span v-if="producto.planMensual">
                <span>
                  {{ producto.divisa.simbolo }}
                </span>
                {{ producto.planMensual.pago.precio }}
              </span>
            </h3>
          </span>
          <span v-else>
            <h3 :class="`plan-list-element-price plan-list-element-price-${producto.class}`">
              <span>
                Gratis
              </span>
            </h3>
          </span>
          <span
            v-if="!producto.planMensual && !producto.planAnual"
            class="plan-list-element-price-frecuency"
          >
            (Toda la vida)
          </span>
          <span
            v-else-if="frecuencySelected === 'anual'"
            class="plan-list-element-price-frecuency"
          >
            (Al año)
          </span>
          <span
            v-else
            class="plan-list-element-price-frecuency"
          >
            (Al mes)
          </span>
          <ul class="plan-list-element-features">
            <li><span>{{ producto.maximo_administradores }}</span> Administradores</li>
            <li><span>{{ producto.maximo_profesores }}</span> Profesores</li>
            <li><span>{{ producto.maximo_instructores }}</span> Instructores</li>
            <li><span>{{ producto.maximo_alumnos }}</span> Alumnos</li>
            <li><span>Ilimitado</span> Proyectos</li>
            <li><span>Ilimitado</span> Mapas de Aprendizaje</li>
            <li><span>Ilimitado</span> Productos</li>
            <li><span>Ilimitado</span> Puntos de Venta</li>
            <li><span>{{ producto.maximo_emails }}</span> Listas de e-mail</li>
            <li><span>{{ producto.universidad }}</span> Universidad</li>
            <li v-if="false"><span>{{ producto.comisiones }}</span>% Comisiones</li>
            <li v-show="producto.integraciones">Integraciones</li>
            <li v-show="producto.clases_vivo && false">Clases en vivo por Zoom</li>
            <li v-show="producto.afiliaciones && false">Afiliaciones</li>
            <li v-show="producto.evaluaciones && false">Evaluaciones</li>
            <li v-show="producto.control_alumnos && false">Control de alumnos</li>
            <li v-show="producto.importacion_alumnos && false">Importación de alumnos</li>
          </ul>
          <a
            v-if="venta.venta.producto_venta === producto.id && frecuencySelected === frecuencyOriginal"
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
          >
            <span>
              Plan Actual
            </span>
          </a>
          <a
            v-else
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
            @click="modalPaymentMethod({
              cliente: venta.cliente,
              divisa: divisa,
              gateways: producto.productoGestion
                ? producto.productoGestion.pasarelas
                : '',
              pasarela: '',
              plan: producto.productoGestion
                ? frecuencySelected === 'mensual'
                  ? producto.planMensual
                  : producto.planAnual
                : '',
              producto: producto,
              venta: venta.venta
            })"
          >
            <span>
              Lo Quiero
            </span>
          </a>
        </article>
      </div>
      <div class="m-edition-billing-my-payments-change-plan-help">
        <h3>¿Necesitas ayuda?</h3>
          <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
      </div>
    </div>
  </div>
  <div
    v-else
    class="m-card-primary m-card-transition m-card-record-info"
  >
    <blockquote class="quote quote-billing-primary quote-first">
      <p>
        <span>
          Este producto ya no esta disponible...
        </span>
      </p>
    </blockquote>
    <div class="m-edition-billing-my-payments-change-plan-help">
      <h3>¿Necesitas ayuda?</h3>
      <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsChangePlanCustomized',
  data () {
    return {
      academiaId: '',
      cantPV: 1,

      classVidroop: [
        {
          nombre: 'Vidroop Inicia',
          class: 'initial',
          order: 0
        },
        {
          nombre: 'Vidroop Avanza',
          class: 'professional',
          order: 1
        },
        {
          nombre: 'Vidroop Crece',
          class: 'expert',
          order: 2
        },
        {
          nombre: 'Vidroop Vuela',
          class: 'business',
          order: 3
        }
      ],

      divisa: {},

      divisaByGestion: [
        {
          id_divisa: 62,
          nombre: 'Euro',
          simbolo: '€',
          iso_code: 'EUR',
          iso_number: 978,
          decimales: 2,
          activa: true
        },

        {
          id_divisa: 49,
          nombre: 'Dólar estadounidense',
          simbolo: '$',
          iso_code: 'USD',
          iso_number: 840,
          decimales: 2,
          activa: true
        },

        {
          id_divisa: 120,
          nombre: 'Peso Argentino',
          simbolo: '$',
          iso_code: 'ARS',
          iso_number: 32,
          decimales: 2,
          activa: true
        }
      ],

      divisas: [],
      divisaSelected: '',
      frecuencyOriginal: '',
      frecuencySelected: '',
      orderProductoActual: -1,
      planSelected: '',
      producto: null,
      productoGestiones: [],
      showLoadingState: 0,
      showLoadingStateProduct: 0,
      suscripcionNotificada: null,
      venta: {},
      ventaReemplazante: null
    }
  },

  watch: {
    divisaSelected () {
      this.divisa = this.divisas.find(divisa => divisa.iso_code === this.divisaSelected)
      this.configVidroop(this.producto, false)
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readProductoPublico()
  },

  methods: {
    modalPaymentMethod (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalChangePlan', params)
    },

    modalViewPendingChangePlan (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalPendingChangePlan', params)
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.configVidroop(this.producto, true)
          this.readChangePlan()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    configVidroop: function (productoVidroop, ban) {
      if (productoVidroop) {
        if (ban) {
          this.frecuencyOriginal = this.venta.suscripcion
            ? this.venta.suscripcion.pago_frecuencia
            : this.venta.venta.pago_frecuencia
          this.frecuencyOriginal === 4
            ? this.frecuencyOriginal = 'anual'
            : this.frecuencyOriginal = 'mensual'
          this.frecuencySelected = this.frecuencyOriginal

          this.divisaSelected = this.venta.venta.divisa_iso_code
            ? this.venta.venta.divisa_iso_code
            : 'EUR'
          this.divisa = this.divisas.find(divisa => divisa.iso_code === this.divisaSelected)
        }

        var configVidroop = this.classVidroop.find(item => {
          return productoVidroop.nombre.toLowerCase().includes(item.nombre.toLowerCase());
        }) || this.classVidroop[1]

        productoVidroop.mostrar = true
        productoVidroop.class = configVidroop.class

        if (productoVidroop.tipo_universidad === 0) {
          productoVidroop.universidad = 'Mini'
        } else {
          productoVidroop.universidad = 'Profesional'
        }

        if (productoVidroop.pago) {
          productoVidroop.divisa = this.divisa
          var productoGestion = this.producto.gestiones.find(gestion => gestion.divisa.id_divisa === this.divisa.id_divisa)
          if (productoGestion) {
            productoVidroop.productoGestion = Object.assign({}, productoGestion)
            let planesM = productoGestion.planes.find(plan => plan.pago.frecuencia === 3)
            let planesA = productoGestion.planes.find(plan => plan.pago.frecuencia === 4)
            if ((planesM || planesA) && productoGestion.activa) {
              Object.assign(productoVidroop, { planMensual: planesM })
              Object.assign(productoVidroop, { planAnual: planesA })
            } else {
              productoVidroop.mostrar = false
            }
          } else {
            productoVidroop.mostrar = false
          }
        } else {
          productoVidroop.divisa = this.divisa
        }
      }
      this.showLoadingState++
    },

    readProductoPublico () {
      this.$services.read('ventas', 'readProductoPublico', {}, [this.$route.params.subid])
        .then(response => {
          this.producto = response.data
          this.readVenta()
          this.showLoadingState++
        })
        .catch(error => {
          this.producto = null
          this.showLoadingState = 7
          console.log(error)
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          this.venta = response.data
          this.readDivisas()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingStateProduct++
        })
    },

    readChangePlan () {
      this.$services.read('ventas', 'readChangePlan', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.ventaReemplazante = null
          } else {
            this.ventaReemplazante = response.data
          }
          this.readSubscriptionNotificada()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readSubscriptionNotificada () {
      this.$services.read('ventas', 'readSubscriptionNotificada', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          if (response.status === 204) {
            this.suscripcionNotificada = null
          } else {
            this.suscripcionNotificada = response.data
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
